class ContentLinksComponent extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('[ref="container"]');
    this.slideshow = this.querySelector('[ref="slideshow"]');
    this.items = [];
    this.slides = [];
    this.currentIndex = 0;
    
    this.init();
  }

  init() {
    if (!this.container) return;
    
    this.items = Array.from(this.container.querySelectorAll('.content-link'));
    
    // Debug: log slideshow structure
    if (this.slideshow) {
      console.log('Slideshow found:', this.slideshow);
      console.log('Slideshow HTML:', this.slideshow.innerHTML);
      
      // Try multiple selectors to find slides
      const slideSelectors = [
        '.slideshow__slide',
        '[data-slide]',
        '.slide',
        '.splide__slide',
        '.swiper-slide',
        'slideshow-slide'
      ];
      
      for (const selector of slideSelectors) {
        const foundSlides = this.slideshow.querySelectorAll(selector);
        if (foundSlides.length > 0) {
          console.log(`Found ${foundSlides.length} slides with selector: ${selector}`);
          this.slides = Array.from(foundSlides);
          break;
        }
      }
      
      console.log('Final slides array:', this.slides);
    }
    
    // Add hover event listeners to each item
    this.items.forEach((item, index) => {
      item.addEventListener('mouseenter', () => this.showSlide(index));
      item.addEventListener('focus', () => this.showSlide(index));
    });

    // Set initial active state
    this.setActiveItem(0);
    this.setActiveSlide(0);
  }

  showSlide(index) {
    console.log(`Switching to slide ${index}`);
    
    if (index === this.currentIndex) return;
    
    this.currentIndex = index;
    this.setActiveItem(index);
    this.setActiveSlide(index);
  }

  setActiveItem(index) {
    // Remove current class from all items
    this.items.forEach(item => item.classList.remove('current'));
    
    // Add current class to active item
    if (this.items[index]) {
      this.items[index].classList.add('current');
    }
  }

  setActiveSlide(index) {
    if (!this.slides.length) {
      console.log('No slides found to switch');
      return;
    }

    console.log(`Setting slide ${index} as active`);

    // Remove active classes from all slides
    this.slides.forEach((slide, i) => {
      slide.classList.remove('is-selected', 'active', 'slideshow__slide--active', 'current');
      slide.style.display = i === index ? 'block' : 'none';
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });
    
    // Add active class to target slide
    if (this.slides[index]) {
      this.slides[index].classList.add('is-selected', 'active', 'slideshow__slide--active', 'current');
      this.slides[index].style.display = 'block';
      this.slides[index].setAttribute('aria-hidden', 'false');
    }

    // Try to update slideshow component if it has methods
    const slideshowComponent = this.slideshow?.querySelector('slideshow-component');
    if (slideshowComponent) {
      console.log('Found slideshow component:', slideshowComponent);
      if (slideshowComponent.goToSlide) {
        slideshowComponent.goToSlide(index);
      } else if (slideshowComponent.setActiveSlide) {
        slideshowComponent.setActiveSlide(index);
      } else {
        console.log('Slideshow component methods not found');
      }
    }
  }
}

// Define the custom element
if (!customElements.get('content-links-component')) {
  customElements.define('content-links-component', ContentLinksComponent);
}

// Fallback for when DOM is already loaded
document.addEventListener('DOMContentLoaded', () => {
  const contentLinksComponents = document.querySelectorAll('content-links-component');
  
  contentLinksComponents.forEach(component => {
    // Force re-initialization if needed
    if (component.items && component.items.length === 0) {
      component.init();
    }
  });
});